module.exports = __webpack_public_path__ + "img/help-inactive.d16c4214.png";